import React from "react";
import { StyledFormElementsWrapper, ContainerGrid } from "../styles";
import FormField from "../../../common/FormField/FormField";
import CustomSelect from "./CustomSelect";

const TemplateDelete = ({
  values,
  handleChange,
  errors,
  touched,
  handleBlur,
  setFieldValue,
  menuItems,
  menuNotice,
  menuTemplateCode,
  getNoticeTemplates,
  cmId,
  radioInputs,
}) => {

  const inputs = [
    {
      type: "select",
      name: "noticeCategory",
      label: "Notice Category",
      required: false,
      items: menuNotice,
    },
    {
      type: "select",
      name: "templateCode",
      label: "Template Code",
      required: false,
      items: menuTemplateCode[values?.noticeCategory]?.length
        ? menuTemplateCode[values?.noticeCategory]?.map(
            ({ id, templateCode }) => ({
              id: id,
              label: templateCode,
              value: templateCode,
            }),
          )
        : [],
    },
  ];

  return (
    <>
      <StyledFormElementsWrapper style={{ marginBottom: 8, marginTop: 15 }}>
        <ContainerGrid className="disabledArrows">
          <CustomSelect
            name="partyId"
            trigger={true}
            {...{
              errors,
              touched,
              setFieldValue,
              menuItems,
              getNoticeTemplates,
            }}
          />

          {inputs.map((input, index) => {
            return (
              <FormField
                key={index}
                menuItems={input.items}
                {...{
                  touched,
                  errors,
                  input,
                  values,
                  handleChange,
                  handleBlur,
                  setFieldValue,
                }}
              />
            );
          })}
        </ContainerGrid>
      </StyledFormElementsWrapper>
    </>
  );
};

export default TemplateDelete;
